module.exports = __webpack_public_path__ + "img/car-green.8244a597.svg";